/**
 * Register Official SRD Pattern Components
 *
 * Called once at app startup to register all 14 official pattern types
 * into the pattern registry. Homebrew patterns are registered separately
 * at runtime when loaded from Firebase.
 *
 * @see campaignFramePatternRegistry.js
 */

import { registerPatterns } from './campaignFramePatternRegistry';
import { FRAME_MECHANIC_TYPES } from './campaignFrameConfig';
import {
  ResourceHarvestPattern,
  FlavorCookingPattern,
  NpcServicePattern,
  TokenPoolPattern,
  DiceCheckPattern,
  DayNightCyclePattern,
  DiseaseTrackerPattern,
  DowntimeMovePattern,
  PassiveInfoPattern,
  FactionRelationsPattern,
  ObjectiveCountdownPattern,
  CurrencyOverridePattern,
  EquipmentOverridePattern,
  ColossalAdversaryPattern,
} from '../components/campaign-frames/patterns';

export const registerOfficialPatterns = () => {
  registerPatterns([
    [FRAME_MECHANIC_TYPES.RESOURCE_HARVEST, ResourceHarvestPattern],
    [FRAME_MECHANIC_TYPES.FLAVOR_COOKING, FlavorCookingPattern],
    [FRAME_MECHANIC_TYPES.NPC_SERVICE, NpcServicePattern],
    [FRAME_MECHANIC_TYPES.TOKEN_POOL, TokenPoolPattern],
    [FRAME_MECHANIC_TYPES.DICE_CHECK, DiceCheckPattern],
    [FRAME_MECHANIC_TYPES.DAY_NIGHT_CYCLE, DayNightCyclePattern],
    [FRAME_MECHANIC_TYPES.DISEASE_TRACKER, DiseaseTrackerPattern],
    [FRAME_MECHANIC_TYPES.DOWNTIME_MOVE, DowntimeMovePattern],
    [FRAME_MECHANIC_TYPES.PASSIVE_INFO, PassiveInfoPattern],
    [FRAME_MECHANIC_TYPES.FACTION_RELATIONS, FactionRelationsPattern],
    [FRAME_MECHANIC_TYPES.OBJECTIVE_COUNTDOWN, ObjectiveCountdownPattern],
    [FRAME_MECHANIC_TYPES.CURRENCY_OVERRIDE, CurrencyOverridePattern],
    [FRAME_MECHANIC_TYPES.EQUIPMENT_OVERRIDE, EquipmentOverridePattern],
    [FRAME_MECHANIC_TYPES.COLOSSAL_ADVERSARY, ColossalAdversaryPattern],
  ]);
};
